import { render } from "./PdfViewerPage.vue?vue&type=template&id=72d36d06"
import script from "./PdfViewerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfViewerPage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/pdfViewer/PdfViewerPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72d36d06"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72d36d06', __exports__)) {
    console.log('reload')
    api.reload('72d36d06', __exports__)
  }
  
  module.hot.accept("./PdfViewerPage.vue?vue&type=template&id=72d36d06", () => {
    console.log('re-render')
    api.rerender('72d36d06', render)
  })

}


export default __exports__